function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'charcoal-black-triblend': 'url("//obsbillet.com/cdn/shop/files/charcoal-black-triblend_120x.png?v=12823790577638817574")','solid-black-triblend': 'url("//obsbillet.com/cdn/shop/files/solid-black-triblend_120x.png?v=17832977734246923053")','emerald-triblend': 'url("//obsbillet.com/cdn/shop/files/emerald-triblend_120x.png?v=7619243844228906312")','brown-triblend': 'url("//obsbillet.com/cdn/shop/files/brown-triblend_120x.png?v=1972672850728852822")','true-royal-triblend': 'url("//obsbillet.com/cdn/shop/files/true-royal-triblend_120x.png?v=9754260973044694201")','navy-triblend': 'url("//obsbillet.com/cdn/shop/files/navy-triblend_120x.png?v=7130959106904853178")','red-triblend': 'url("//obsbillet.com/cdn/shop/files/red-triblend_120x.png?v=3612694568381452557")','oatmeal-triblend': 'url("//obsbillet.com/cdn/shop/files/oatmeal-triblend_120x.png?v=1595480396401955947")','white-fleck-triblend': 'url("//obsbillet.com/cdn/shop/files/white-fleck-triblend_120x.png?v=16980387142613288852")','solid-white-triblend': 'url("//obsbillet.com/cdn/shop/files/solid-white%20triblend_120x.png?v=3974")','red-anodized': 'url("//obsbillet.com/cdn/shop/files/red-anodized_120x.png?v=2178082925123905796")','black-anodized': 'url("//obsbillet.com/cdn/shop/files/black-anodized_120x.png?v=9025490836451921912")','blue-anodized': 'url("//obsbillet.com/cdn/shop/files/blue-anodized_120x.png?v=14476694687248205352")','purple-anodized': 'url("//obsbillet.com/cdn/shop/files/purple-anodized_120x.png?v=1910874400092641280")','green-anodized': 'url("//obsbillet.com/cdn/shop/files/green-anodized_120x.png?v=9286462118155988462")','camo': 'url("//obsbillet.com/cdn/shop/files/camo_120x.png?v=3974")','black-charcoal': 'url("//obsbillet.com/cdn/shop/files/black-charcoal_120x.png?v=15795465995178200571")','black-black': 'url("//obsbillet.com/cdn/shop/files/black-black_120x.png?v=1884559075138082915")','black-white': 'url("//obsbillet.com/cdn/shop/files/black-white_120x.png?v=5519387790410807971")','charcoal-black': 'url("//obsbillet.com/cdn/shop/files/charcoal-black_120x.png?v=3942962963307653714")','heather-grey-black': 'url("//obsbillet.com/cdn/shop/files/heather%20grey-black_120x.png?v=3974")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
